import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  Box,
  Typography,
  TextField,
  Paper,
  Grid,
  Chip,
  Button,
  InputAdornment,
} from '@mui/material';
import {
  Straighten as StraightenIcon,
  Height as HeightIcon,
  Refresh as RefreshIcon,
} from '@mui/icons-material';

import productDimensionsStore from '../stores/productDimensionsStore';

const ProductDimensionsEditor = observer(({ selectedProduct, onDimensionsChange }) => {
  if (!selectedProduct || !productDimensionsStore.hasDimensions) {
    return null;
  }

  const handleDimensionChange = (dimensionKey, value) => {
    productDimensionsStore.updateDimensionValue(dimensionKey, value);
    // Вызываем колбек при изменении размеров
    if (onDimensionsChange) {
      onDimensionsChange();
    }
  };

  const handleReset = () => {
    productDimensionsStore.resetDimensions();
    // Вызываем колбек при сбросе размеров
    if (onDimensionsChange) {
      onDimensionsChange();
    }
  };

  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h5" component="h2" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <StraightenIcon color="primary" />
          Размеры кабины для &quot;{selectedProduct.name}&quot;
        </Typography>
        
        {productDimensionsStore.isModified && (
          <Button
            size="small"
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={handleReset}
            sx={{ textTransform: 'none' }}>
            Сбросить изменения
          </Button>
        )}
      </Box>

      <Grid container spacing={3}>
        {productDimensionsStore.sortedDimensions.map(([dimensionKey, dimension]) => (
          <Grid item xs={12} sm={6} md={4} key={dimensionKey}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                {dimension.is_height ? (
                  <HeightIcon color="primary" fontSize="small" />
                ) : (
                  <StraightenIcon color="primary" fontSize="small" />
                )}
                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                  {dimension.label}
                </Typography>
              </Box>

              <TextField
                value={dimension.value}
                onChange={(e) => handleDimensionChange(dimensionKey, e.target.value)}
                type="number"
                variant="outlined"
                size="small"
                fullWidth
                InputProps={{
                  endAdornment: <InputAdornment position="end">мм</InputAdornment>,
                  inputProps: {
                    min: 0,
                    max: 5000,
                    step: 1,
                  },
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                      borderColor: 'primary.main',
                    },
                  },
                }}
              />

              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  {!dimension.has_glass && (
                    <Chip
                      label="Сторона без стекла"
                      size="small"
                      color="default"
                      variant="outlined"
                      sx={{ fontSize: '0.75rem' }}
                    />
                  )}
                </Box>
                
                {productDimensionsStore.originalDimensions[dimensionKey] && 
                 dimension.value !== productDimensionsStore.originalDimensions[dimensionKey].value && (
                  <Chip
                    label="Изменено"
                    size="small"
                    color="warning"
                    variant="outlined"
                    sx={{ fontSize: '0.75rem' }}
                  />
                )}
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>

    
    </Paper>
  );
});

export default ProductDimensionsEditor; 